import { FC } from "react"
import cx from "classnames"
import { AiOutlineInfoCircle } from "react-icons/ai"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const InfoIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return <AiOutlineInfoCircle className={cx("w-5 h-5", className)} {...rest} />
}

export default InfoIcon
